(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('sodName', sodNameFilter);

    function sodNameFilter(lodash, $filter) {
        return function(data, template) {
            //console.log('%csodName', 'color: #8e44ad', data);
            var first_name = lodash.get(data, 'first_name', '');
            var last_name = lodash.get(data, 'last_name', '');
            var middle_name = lodash.get(data, 'middle_name', '');
            if (!template) {
                var name = first_name;
                if (middle_name.length > 0) {
                    name += ' ' + middle_name;
                }
                name += ' ' + last_name;
                return name;
            } else {
                var nameArray = [first_name, last_name, middle_name];
                return $filter('stringFormat')(template, nameArray);
            }
        };
    }
})();